import { Injectable } from '@angular/core';
import { flatten } from '@angular/compiler';
import { CookieService } from 'ngx-cookie-service';
import { S1DataService } from './s1data.service'
import { Observable } from 'rxjs/Observable';
import { IS1Token } from '../models/IS1Token'

@Injectable()
export class AuthService {
  private readonly tokenCookieName: string = "token";
  private readonly emailCookieName: string = "email";
  private readonly userCookieName: string = "user";
 
  constructor(private cookieService: CookieService, private s1dataservice: S1DataService) {
  }

  isAuthenticated(): boolean {
    return this.cookieService.check(this.tokenCookieName);
  }

  checkAuthentication(username: string, password: string): Observable<IS1Token> {
    return this.s1dataservice.getSampleOneUserToken(username, password).map(token => {
      var expires = new Date();
      expires.setSeconds(token.expires_in);
      this.cookieService.set(this.tokenCookieName, token.access_token, expires);
      this.s1dataservice.getUserInfo(token.userId).subscribe(user => {
        this.cookieService.set(this.emailCookieName, user.email, expires);
        this.cookieService.set(this.userCookieName, username, expires);
      });
      return token;
    });
  }

  logout() {
    this.cookieService.delete(this.tokenCookieName);
    this.cookieService.delete(this.emailCookieName);
  }

  public get Token(): string {
    if (this.cookieService.check(this.tokenCookieName))
      return this.cookieService.get(this.tokenCookieName);
    return null;
  }

  public get Email(): string {
    if (this.cookieService.check(this.emailCookieName))
      return this.cookieService.get(this.emailCookieName);
    return null;
  }


  public get User(): string {
    if (this.cookieService.check(this.userCookieName))
      return this.cookieService.get(this.userCookieName);
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/auth-service.service.ts